export const scrollToTop = () => {
	const container = document.querySelector("div[class*='with-perfect-scroll-bar']");

	if (container) {
		container.scrollTop = 0;
	}
};

const b64toBlob = (b64Data, contentType, sliceSize) => {
	contentType = contentType || '';
	sliceSize = sliceSize || 512;

	const byteCharacters = atob(b64Data);
	let byteArrays = [];

	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		const slice = byteCharacters.slice(offset, offset + sliceSize);

		const byteNumbers = new Array(slice.length);
		for (var i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);

		byteArrays.push(byteArray);
	}

	const blob = new Blob(byteArrays, { type: contentType });
	return blob;
}

export const getImageFromImport = (base64Image) => {
	if (!base64Image.includes('base64')) {
		return null;
	}
	// Split the base64 string in data and contentType
	const block = base64Image.split(";");
	// Get the content type
	const contentType = block[0].split(":")[1];
	// get the real base64 content of the file
	const realData = block[1].split(",")[1];
	// Convert to blob
	const blob = b64toBlob(realData, contentType);
	// Convert to file
	const file = new File([blob], "default.png", { type: blob.type })
	return file;
}

export const formatPhoneNumber = (phoneNumber) => {
	return phoneNumber ? phoneNumber.replace(/\D/g, '') : null;
}

export const trimStringForQuery = (value) => {
	if (typeof value === 'string') {
		return value.slice(0, 255);
	}

	return value;
}